const list1 = document.getElementsByClassName("acc-toggle");
const list2 = document.getElementsByClassName("acc-content");

for (let i = 0; i < list1.length; i++) {
  list1[i].addEventListener("click", () => {
    for (let j = 0; j < list2.length; j++) {
      list2[j].classList.remove("active");
    }
    list2[i].classList.add("active");
  });
}
